class HeaderComponent {
    constructor() {
		this.lastScrollTop = 0;
		this.delta = 5;
        this.ticking = false;
        this.isMenuOpen = false;
		this.isContactOpen = false;
		
		this.handleMobileMenu = this.handleMobileMenu.bind(this);
		this.handleContactPanel = this.handleContactPanel.bind(this);
		this.handleResize = this.handleResize.bind(this);

		// Listen for scroll events
        // Poll the scroll funk
        this.headerEl = document.querySelector('.js-header');
		window.addEventListener('scroll', (e) => {
			if (!this.ticking) {
				window.requestAnimationFrame(() => {
					this.scroll(this.headerEl);
					this.ticking = false;
				});
				this.ticking = true;
			}
        });
        
        // Handle mobile menu
        this.mobileMenuEl = document.querySelector('.js-mobile-menu');
        this.mobileMenuEl.addEventListener('click', this.handleMobileMenu);

        this.setPositionClass(this.headerEl);
	}

	scroll(el) {
		// Make sure they scroll more than delta
		if (Math.abs(this.lastScrollTop - window.scrollY) <= this.delta)
			return;
		
		if (window.scrollY > this.lastScrollTop && window.scrollY > (window.outerHeight * .05)){
			// Scroll Down
			this.hide();
		} else {
			//Scroll Up
			if (window.scrollY + window.outerHeight < getDocHeight()) {
				this.show();
			}
            this.setPositionClass(el);
		}
		
        this.lastScrollTop = window.scrollY;
        
        function getDocHeight() {
            let d = document;
            return Math.max(
                d.body.scrollHeight, d.documentElement.scrollHeight,
                d.body.offsetHeight, d.documentElement.offsetHeight,
                d.body.clientHeight, d.documentElement.clientHeight
            );
        }
    }
    
    handleMobileMenu() {
        this.headerEl.classList[this.isMenuOpen ? 'remove':'add']('cfo-header--open');
		this.isMenuOpen = !this.isMenuOpen;
		
		if (this.isContactOpen) {
			this.handleContactPanel();
		}
	}
	
	handleContactPanel() {
		if (!this.isContactOpen) {
			this.headerEl.style.transform = `translateY(${this.contactPanel.panelEl.offsetHeight}px)`;
		} else {
			this.headerEl.removeAttribute('style');
		}
		this.headerEl.classList[this.isContactOpen ? 'remove':'add']('cfo-header--contact-open');
		this.isContactOpen = !this.isContactOpen;

		window[this.isContactOpen ? 'addEventListener':'removeEventListener']('resize', this.handleResize);
	}

	handleResize() {
		this.headerEl.style.transform = `translateY(${this.contactPanel.panelEl.offsetHeight}px)`;
	}

	hide() {
		this.headerEl.classList.add('cfo-header--hide');
	}

	show() {
		this.headerEl.classList.remove('cfo-header--hide');
    }

    setPositionClass(el) {

        if (window.scrollY > (window.outerHeight * .05)) {
            el.classList.remove('cfo-header--top');
            el.classList.add('cfo-header--bgcolor');
        } else {
            el.classList.remove('cfo-header--bgcolor');
            el.classList.add('cfo-header--top');
        }
    }
}

export default HeaderComponent;
